import type { Release } from '../releases';

export default {
  id: '2026-11-02-support-kb-draft',
  at: '2026-11-02T07:49:00Z',
  title: 'Статья в базу знаний из закрытого обращения',
  modules: [],
  items: [
    'В закрытом или отвеченном обращении у специалиста поддержки есть кнопка «Подготовить статью»: из переписки получается черновик «Вопрос — ответ» в разделе базы знаний «Ответы поддержки». Если Pilot подключён, текст готовит он, иначе в черновик попадают вопрос и ответ поддержки.',
    'Черновик сразу уходит на проверку: владелец раздела правит и публикует его, и следующий такой вопрос можно найти в базе знаний и в ответах Pilot без обращения.',
    'Суммы, ИИН, телефоны и почта в статью не попадают, имена и названия проверяет владелец раздела перед публикацией. По одному обращению готовится одна статья — в обращении видно, какая.',
  ],
  why: 'Одни и те же вопросы приходили в поддержку снова и снова: ответ специалиста оставался в одном обращении, и его не видели остальные.',
  link: '/kb',
} satisfies Release;
